// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__S431g","author":"Table_author__1VNve","authorImage":"Table_authorImage__1h7d_","unreadRow":"Table_unreadRow__1447t"};